export { EllipsisComponent } from './ellipsis.component';
export { AdEllipsisModule } from './ellipsis.module';
